import React from 'react';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '3rem',
      color: '#e2e8f0'
    }}>
      <div style={{
        width: '60px',
        height: '60px',
        border: '4px solid rgba(96, 165, 250, 0.2)',
        borderTop: '4px solid #60a5fa',
        borderRadius: '50%',
        margin: '0 auto 1rem',
        animation: 'spin 1s linear infinite'
      }} />
      <div style={{ 
        color: '#94a3b8',
        fontFamily: '"DM Sans", system-ui, sans-serif'
      }}>{message}</div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;

